import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { APP_NAME, APP_DOMAIN } from "../common/constants";

interface SEOProps {
  title: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description = "Cutora is a fast and secure online video processing platform. Clip, cut, trim and convert videos you own or are licensed to use. Built for creators, professionals and developers.",
  keywords = "cutora, video clipping tool, online video cutter, video trimmer, video converter, safe video editing tool, video processing platform, creator tools, professional video tools, developer video tools, video api platform, online media processing, trim videos online, convert videos online",
  image = `${APP_DOMAIN}/favicon-512x512.png`,
  url = `${APP_DOMAIN}`,
}) => {
  useEffect(() => {
    document.title = title;

    const descTag = document.querySelector('meta[name="description"]');
    if (descTag) {
      descTag.setAttribute("content", description);
    } else {
      const newTag = document.createElement("meta");
      newTag.name = "description";
      newTag.content = description;
      document.head.appendChild(newTag);
    }
  }, [title, description]);

  return (
    <Helmet>
      <meta name="keywords" content={keywords} />
      <meta name="author" content={`${APP_NAME} Team`} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default SEO;
